import { render, staticRenderFns } from "./AiEntry.vue?vue&type=template&id=624961ce&scoped=true&"
import script from "./AiEntry.vue?vue&type=script&lang=js&"
export * from "./AiEntry.vue?vue&type=script&lang=js&"
import style0 from "./AiEntry.vue?vue&type=style&index=0&id=624961ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624961ce",
  null
  
)

export default component.exports